import React from "react";
import Plot from "react-plotly.js";

import { getPlotlyIcons } from "constants/plotly.const";

class AnalyticsCIPOverlayPlot extends React.Component {
  getChartConfig() {
    return getPlotlyIcons(this.props.onDownloadPlot, this.props.onPlotRefresh,this.props.onToggleSpikeLine, this.props.isSpikeLineActive);
  }
  handleDoubleClick() {
    return false;
  }

  render() {
    return (
      <Plot
        className="analytics-cip--chart"
        data={this.props.Data}
        layout={this.props.Layout}
        config={this.getChartConfig()}
        useResizeHandler
        scrollZoom
        style={{ width: "100%", height: "100%" }}
        onRelayout={this.props.onPlotZoom}
        onLegendClick={() => false}
        onDoubleClick={this.handleDoubleClick}
        onUnhover={e => (e.event.target.style.cursor = "")}
      />
    );
  }
}

export default AnalyticsCIPOverlayPlot;
